"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation createOrganizationFee($orgId: String!, $fee: FeeInput!) {
    createOrganizationFee(orgId: $orgId, fee: $fee) {
      _id
      name
      orgId
      eventId
      type
      value
      appliedTo
      appliedBy
      minAppliedToPrice
      maxAppliedToPrice
      filters
      paymentMethods
      createdBy
      createdAt
      updatedBy
      updatedAt
      disabled
      paymentMethods
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=createOrganizationFee.mutation.js.map